/**
 * Generated runtime TestId mirror for frontend/src/pages/FunctionGroups.tsx.
 * DO NOT EDIT MANUALLY — re-run scripts/generate-testid-constants.py.
 *
 * Runtime mirror — same values as frontend/e2e/helpers/testids/. Help maps
 * under frontend/src/locales/ import this module to express computed-property
 * keys (e.g. `[XxxTestIds.fooBar]: '...'`).
 */

import type { TestIdPrefix } from "./types.ts";

export const FunctionGroupsTestIds = {
  btnNewFunctionGroup: "btn-new-function-group",
  colName: "col-name",
  colOwner: "col-owner",
  colType: "col-type",
  functionGroupsList: "function-groups-list",
  linkFgDetail: (fg_id: string) => `link-fg-detail-${fg_id}`,
  linkFgDetailPrefix: () => "link-fg-detail-" as TestIdPrefix
} as const;
